import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import styles from "./IncludedCards.module.sass";
import Card from "../../../components/Card";
import Tooltip from "../../../components/Tooltip";
import SearchInput from "../../../components/SearchInput";
import Loader from "../../../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { fetchCards } from "../../../app/cards/cards.slice";
import { parseSearchCardTags } from "../../../utils";
import TableComponent from "../../../components/TableComponent";
import { useHistory } from "react-router";
import Switch from "../../../components/Switch";
import stylescheckbox from "./../NameAndDescription/NameAndDescription.module.sass";
import { BiPlus } from "react-icons/bi";

const columns = [
  {
    header: 'Char',
    accessor: 'char'
  },
  {
    header: 'Pinyin',
    accessor: 'pinyin'
  },
  {
    header: 'Translation',
    accessor: 'translation'
  },
  {
    header: 'Actions',
    accessor: 'actions'
  },
]



const SEARCH_DEBOUNCE_MS = 300;

const IncludedCards = ({checkedCards, onCheckedCardsChange, className, selectedCards, setSelectedCards, deckId }) => {

  const history = useHistory();
  const dispatch = useDispatch();
  const { user, cards } = useSelector((state) => state);

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const searchTimeoutRef = useRef(null);

  const handleSwitchChange = (newValue) => {
    setNotChequedContext(newValue);
    onCheckedCardsChange(newValue); // Propaga hacia arriba
  };

  const [notChequedContext, setNotChequedContext] = useState(false);

  useEffect(() => {
    if (user.value) {
      dispatch(fetchCards({ take: 100, skip: 0 }));
    }
  }, [user.value]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    };
  }, []);

  const handleSearch = (term) => {
    setSearchTerm(term);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => {
      dispatch(
        fetchCards({
          take: 100,
          skip: 0,
          search: term || undefined,
        })
      );
    }, SEARCH_DEBOUNCE_MS);
  };

  const handleAddCard = (parsedCard) => {
    if (!selectedCards.find((el) => el.value === parsedCard.value)) {
      setSelectedCards((currentVal) => [...currentVal, parsedCard]);
    }
  };

  const handleRemoveCard = (rCard) => {
    setSelectedCards((currentVal) => currentVal.filter((c) => c.value !== rCard.value));
  };

  const searchResults = (cards?.value || []).map((card) => parseSearchCardTags(card));


  useEffect(() => {
    setData(
      selectedCards.map((card) => ({
        char: { data: card?.character, dataComponent: card?.character },
        pinyin: { data: card?.pinyin, dataComponent: card?.pinyin },
        translation: { data: card?.translation, dataComponent: card?.translation },
        actions: {
          data: "actions",
          dataComponent: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <button onClick={() => handleRemoveCard(card)} style={{ color: "red" }}>
                Delete
              </button>
              <button
                onClick={() =>
                  history.push(
                    `/card/edit/${card?.value}?deckId=${deckId}&notChequedContext=${notChequedContext}`
                  )
                }
                style={{ color: "blue", marginLeft: 20 }}
              >
                Edit
              </button>
            </div>
          ),
        },
      }))
    );
  }, [selectedCards, deckId, notChequedContext, history]);



// 7. Componente Toggle para añadir en el JSX
  const FilterToggle = () => (
      <div className={stylescheckbox.switchContainer}>
        Not Chequed cards
        <Switch className={styles.switch} value={checkedCards}
                onChange={() => handleSwitchChange(!checkedCards)}
        />
      </div>
  );


  return (



    <Card className={cn(styles.card, className)} title="Included cards" classTitle="title-blue">

      <div className={styles.card}>
        <FilterToggle />
      </div>

      <div className={styles.images}>
        {/* <Dropdown
          className={styles.field}
          label="Category"
          tooltip="Maximum 100 characters. No HTML or emoji allowed"
          value={category}
          setValue={setCategory}
          options={optionsCategory}
        /> */}
        <div className={styles.label}>
          Select cards that are included in this deck{" "}
          <Tooltip
            className={styles.tooltip}
            title="Search and click on a card to add it to the deck"
            icon="info"
            place="right"
          />
        </div>
        <div className={styles.searchSection}>
          <SearchInput
            placeholder="Search cards by character, pinyin or translation..."
            value={searchTerm}
            onChange={handleSearch}
            onClear={() => handleSearch("")}
            size="medium"
          />
        </div>
        <div className={styles.resultsSection}>
          <div className={styles.resultsHeader}>
            <span>Search results</span>
            {cards.isLoading && (
              <span className={styles.loading}>
                <Loader />
              </span>
            )}
          </div>
          <div className={styles.cardList}>
            {searchResults.length === 0 && !cards.isLoading ? (
              <div className={styles.emptyState}>
                {searchTerm ? "No cards found. Try a different search." : "Type to search for cards to add."}
              </div>
            ) : (
              searchResults.map((parsedCard) => {
                const isAdded = selectedCards.some((c) => c.value === parsedCard.value);
                return (
                  <div
                    key={parsedCard.value}
                    className={cn(styles.cardRow, { [styles.added]: isAdded })}
                    onClick={() => !isAdded && handleAddCard(parsedCard)}
                  >
                    <div className={styles.cardChar}>{parsedCard.character}</div>
                    <div className={styles.cardInfo}>
                      <span className={styles.cardPinyin}>{parsedCard.pinyin}</span>
                      <span className={styles.cardTranslation}>{parsedCard.translation}</span>
                    </div>
                    <div className={styles.cardAction}>
                      {isAdded ? (
                        <span className={styles.addedBadge}>Added</span>
                      ) : (
                        <button
                          type="button"
                          className={styles.addBtn}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAddCard(parsedCard);
                          }}
                          aria-label="Add card"
                        >
                          <BiPlus size={20} />
                          Add
                        </button>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div style={{ marginTop: 12 }}>
          <TableComponent 
            title="Selected Cards"
            isCardStyle={false}
            columns={columns}
            paginate={20}
            data={data}
            maxHeight="400px"
          />
        </div>
        {/* <div style={{ marginTop: 12 }}>
          {selectedCards.length === 0 ? (
            "No cards selected yet"
          ) : (
            <SelectedTags
              tags={selectedCards.map((el, index) => ({
                value: el.value,
                id: `${index}`,
                title: `${el.character} - ${el.label}`,
              }))}
              onTagRemove={handleRemoveCard}
            />
          )}
        </div> */}
      </div>
    </Card>
  );
};

export default IncludedCards;
